(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduceMotion) return;

  // Coarse pointers = finger/stylus (phones, tablets). Fine = mouse.
  const isTouch = window.matchMedia('(hover: none), (pointer: coarse)').matches;

  const stages = document.querySelectorAll('[data-collage-stage]');
  if (!stages.length) return;

  stages.forEach((stage) => {
    const items = stage.querySelectorAll('[data-collage-item]');
    if (!items.length) return;

    let rect = stage.getBoundingClientRect();
    let rafId = null;
    let target = { x: 0.5, y: 0.5 }; // normalized 0–1
    let current = { x: 0.5, y: 0.5 };
    let active = false;
    let touching = false; // true while a finger is actively on the stage

    const updateRect = () => { rect = stage.getBoundingClientRect(); };
    window.addEventListener('resize', updateRect, { passive: true });
    window.addEventListener('scroll', updateRect, { passive: true });

    const applyOffsets = () => {
      const ox = current.x - 0.5;
      const oy = current.y - 0.5;
      items.forEach((el) => {
        const depth = parseFloat(el.dataset.depth || '20');
        // Touch mode motion is a bit softer so it reads as atmospheric
        const factor = isTouch ? 0.75 : 1;
        const mx = -ox * depth * factor;
        const my = -oy * depth * factor;
        el.style.setProperty('--mx', `${mx.toFixed(2)}px`);
        el.style.setProperty('--my', `${my.toFixed(2)}px`);
      });
    };

    const loop = () => {
      current.x += (target.x - current.x) * 0.12;
      current.y += (target.y - current.y) * 0.12;
      applyOffsets();

      const delta = Math.abs(target.x - current.x) + Math.abs(target.y - current.y);
      if (delta > 0.001) {
        rafId = requestAnimationFrame(loop);
      } else {
        active = false;
        cancelAnimationFrame(rafId);
      }
    };

    const start = () => {
      if (!active) {
        active = true;
        loop();
      }
    };

    const setPointer = (clientX, clientY) => {
      updateRect();
      const x = (clientX - rect.left) / rect.width;
      const y = (clientY - rect.top) / rect.height;
      target.x = Math.max(0, Math.min(1, x));
      target.y = Math.max(0, Math.min(1, y));
      start();
    };

    // --- Pointer-driven parallax (both mouse and touch) ---
    // For touch, touch-action: pan-y ensures vertical drags become scrolls
    // (no pointermove fires), while horizontal drags do reach us here.
    stage.addEventListener('pointerdown', (e) => {
      if (e.pointerType === 'touch') touching = true;
      setPointer(e.clientX, e.clientY);
    }, { passive: true });

    stage.addEventListener('pointermove', (e) => {
      setPointer(e.clientX, e.clientY);
    }, { passive: true });

    const endTouch = (e) => {
      if (e.pointerType === 'touch') {
        touching = false;
        // Return to scroll-linked neutral instead of snapping hard
        applyScrollParallax();
      }
    };
    stage.addEventListener('pointerup', endTouch, { passive: true });
    stage.addEventListener('pointercancel', endTouch, { passive: true });
    stage.addEventListener('pointerleave', (e) => {
      if (e.pointerType === 'mouse') {
        target.x = 0.5;
        target.y = 0.5;
        start();
      } else {
        endTouch(e);
      }
    }, { passive: true });

    // --- Scroll-linked parallax (touch devices, when no finger is down) ---
    const applyScrollParallax = () => {
      if (!isTouch || touching) return;
      const vh = window.innerHeight || document.documentElement.clientHeight;
      const r = stage.getBoundingClientRect();
      const stageCenter = r.top + r.height / 2;
      const viewportCenter = vh / 2;
      const range = vh / 2 + r.height / 2;
      const norm = Math.max(-1, Math.min(1, (stageCenter - viewportCenter) / range));
      // Map -1..1 → 0..1 for vertical drift; keep x centered
      target.y = (norm + 1) / 2;
      target.x = 0.5;
      start();
    };

    if (isTouch) {
      window.addEventListener('scroll', applyScrollParallax, { passive: true });
      applyScrollParallax();
    }

    // --- Tap/hover lift on individual images ---
    // For mouse: hover lifts. For touch: briefly lift on tap, then release.
    items.forEach((item) => {
      item.addEventListener('pointerenter', (e) => {
        if (e.pointerType === 'mouse') item.classList.add('is-hover');
      });
      item.addEventListener('pointerleave', () => item.classList.remove('is-hover'));

      item.addEventListener('pointerdown', (e) => {
        if (e.pointerType !== 'touch') return;
        item.classList.add('is-hover');
      }, { passive: true });

      const clearTap = () => item.classList.remove('is-hover');
      item.addEventListener('pointerup', clearTap, { passive: true });
      item.addEventListener('pointercancel', clearTap, { passive: true });
    });
  });
})();